module.exports = __webpack_public_path__ + "img/home-pg1.367eb17f.png";